// import * as Constants from './constants.js';
import * as ExternalLogos from './externals.js';

const MISC_LOGOS_CONSTANTS = {
	DEFAULT: 'DEFAULT',
	SWISH: 'TRUSTLY_SWISH',
	PAYPAL: 'PAYPAL',
	TRUSTLY: 'GLUEPAY',
	CREDIT_CARD: 'Credit_Card',
	MOBILEPAY_COLOR: 'MOBILEPAY',
	MASTERCARD: 'MASTERCARD',
	KLARNA: 'KLARNA',
	KLARNA_BW: 'KLARNA_BW',
	VISA_COLOR: 'VISA',
	DEFAULT_BW: 'DEFAULT_BW',
	SWISH_BW: 'TRUSTLY_SWISH_BW',
	PAYPAL_BW: 'PAYPAL_BW',
	TRUSTLY_BW: 'GLUEPAY_BW',
	CREDIT_CARD_BW: 'CREDIT_CARD_BW',
	MOBILEPAY: 'MOBILEPAY_BW',
	MASTERCARD_BW: 'MASTERCARD_BW',
	VISA: 'VISA_BW',
	P24_COLOR: 'P24_COLOR',
	P24_WHITE: 'P24_WHITE',
	ADYEN_IDEAL_BW: 'ADYEN_IDEAL_BW',
	ADYEN_IDEAL_COLOR: 'ADYEN_IDEAL_COLOR'
};

const MISC_LOGO_MAPPING = {
	[MISC_LOGOS_CONSTANTS.DEFAULT]: ExternalLogos.LogoDefaultBank,
	[MISC_LOGOS_CONSTANTS.SWISH]: ExternalLogos.LogoSwishColor,
	[MISC_LOGOS_CONSTANTS.PAYPAL]: ExternalLogos.LogoPaypalColor,
	[MISC_LOGOS_CONSTANTS.TRUSTLY]: ExternalLogos.LogoTrustlyColor,
	[MISC_LOGOS_CONSTANTS.CREDIT_CARD]: ExternalLogos.LogoCreditCardColor,
	[MISC_LOGOS_CONSTANTS.MOBILEPAY_COLOR]: ExternalLogos.LogoMobilePayColor,
	[MISC_LOGOS_CONSTANTS.MASTERCARD]: ExternalLogos.LogoMasterCardColor,
	[MISC_LOGOS_CONSTANTS.KLARNA]: ExternalLogos.LogoKlarnaColor,
	[MISC_LOGOS_CONSTANTS.KLARNA_BW]: ExternalLogos.LogoKlarna,
	[MISC_LOGOS_CONSTANTS.VISA_COLOR]: ExternalLogos.LogoVisaColor,
	[MISC_LOGOS_CONSTANTS.DEFAULT_BW]: ExternalLogos.LogoDefaultBankBW,
	[MISC_LOGOS_CONSTANTS.SWISH_BW]: ExternalLogos.LogoSwish,
	[MISC_LOGOS_CONSTANTS.PAYPAL_BW]: ExternalLogos.LogoPaypalBW,
	[MISC_LOGOS_CONSTANTS.TRUSTLY_BW]: ExternalLogos.LogoTrustly,
	[MISC_LOGOS_CONSTANTS.CREDIT_CARD_BW]: ExternalLogos.LogoCreditCard,
	[MISC_LOGOS_CONSTANTS.MOBILEPAY]: ExternalLogos.LogoMobilePay,
	[MISC_LOGOS_CONSTANTS.MASTERCARD_BW]: ExternalLogos.LogoMasterCard,
	[MISC_LOGOS_CONSTANTS.VISA]: ExternalLogos.LogoVisa,
	[MISC_LOGOS_CONSTANTS.P24_COLOR]: ExternalLogos.LogoP24Color,
	[MISC_LOGOS_CONSTANTS.P24_WHITE]: ExternalLogos.LogoP24White,
	[MISC_LOGOS_CONSTANTS.ADYEN_IDEAL_BW]: ExternalLogos.LogoAdyenIdealBW,
	[MISC_LOGOS_CONSTANTS.ADYEN_IDEAL_COLOR]: ExternalLogos.LogoAdyenIdealColor
};
export { MISC_LOGO_MAPPING, MISC_LOGOS_CONSTANTS };
